// import React from "react";

// function Summary({ cartItems, cartSummary }) {
//   const subtotal = Number(cartSummary.subtotal || 0);
//   const total = Number(cartSummary.total || 0);
//   const discount = Number(cartSummary.discount || 0);
//   const shipping = Number(cartSummary.shipping || 0);

//   const totalWithoutDiscount = cartItems.reduce((sum, item) => {
//     return sum + item.mrp * item.quantity;
//   }, 0);

//   const totalSaving = (cartSummary.subtotal || 0) - (cartSummary.total || 0);

//   return (
//     <>
//       <ul className="list-total p-0">
//         {/* {totalWithoutDiscount && (
//           <li className="total-item d-flex justify-content-between">
//             <span>SubTotal:</span>
//             <span className="fw-medium text-decoration-line-through">
//               ₹{totalWithoutDiscount.toFixed(2)}
//             </span>
//           </li>
//         )} */}

//         <li className="total-item d-flex justify-content-between">
//           <span>Subtotal (After Discount):</span>
//           <span className="fw-medium">₹{subtotal.toFixed(2)}</span>
//         </li>

//         {discount > 0 && (
//           <li className="total-item d-flex justify-content-between">
//             <span>Coupon Discount:</span>
//             <span className="fw-medium text-success">
//               -₹{discount.toFixed(2)}
//             </span>
//           </li>
//         )}

//         <li className="total-item d-flex justify-content-between">
//           <span>Shipping:</span>
//           <span className="fw-medium">+ ₹{shipping.toFixed(2)}</span>
//         </li>
//       </ul>


//       <div className="subtotal d-flex justify-content-between">
//         <span>Total:</span>
//         <span className="total-price-order fw-bold">₹{total.toFixed(2)}</span>
//       </div>

//       {totalSaving > 0 && (
//         <div className="text-success mt-2">
//           You saved ₹{totalSaving.toFixed(2)} on this order!
//         </div>
//       )}
//     </>
//   );
// }

// export default Summary;



import React from "react";

function Summary({ cartItems, cartSummary }) {
  const subtotal = Number(cartSummary?.subtotal || 0);
  const total = Number(cartSummary?.total || 0);
  const discount = Number(cartSummary?.discount || 0);
  const shipping = Number(cartSummary?.shipping || 0);

  const totalSaving = subtotal - total + discount;

  return (
    <div className="space-y-3">
      <ul className="space-y-2 text-sm text-[#5e564f]">
        <li className="flex items-center justify-between">
          <span>Subtotal:</span>
          <span className="font-medium text-[#181512]">
            ₹{subtotal.toFixed(2)}
          </span>
        </li>

        {discount > 0 && (
          <li className="flex items-center justify-between text-[#4e6b4a]">
            <span>Coupon Discount:</span>
            <span className="font-medium">
              -₹{discount.toFixed(2)}
            </span>
          </li>
        )}

        <li className="flex items-center justify-between">
          <span>Shipping:</span>
          <span className="font-medium text-[#181512]">
            {shipping === 0 ? "Free" : `+₹${shipping.toFixed(2)}`}
          </span>
        </li>
      </ul>

      <hr className="my-2 border-[#eee7df]" />

      <div className="flex items-center justify-between">
        <span className="text-base font-semibold text-[#181512]">
          Total Amount:
        </span>

        <span className="font-['Cormorant_Garamond',serif] text-xl font-semibold text-[#a63c06]">
          ₹{total.toFixed(2)}
        </span>
      </div>

      {totalSaving > 0 && (
        <div className="rounded-lg border border-[#8faa88]/30 bg-[#dfe9dc]/50 px-3 py-2 text-center text-xs font-medium text-[#374d35]">
          You are saving ₹{totalSaving.toFixed(2)} on this order!
        </div>
      )}
    </div>
  );
}

export default Summary;